<template>
	<div class="w-full">
		<div
			class="relative flex h-[390px] flex-col items-center overflow-clip rounded from-[#CCECFF] via-[#FCE8C3] to-[#FF8BA0] bg-gradient-[90deg] md:h-[180px] xl:h-[210px]"
		>
			<!-- group TL -->
			<div
				class="relative -left-[50px] w-full scale-75 sm:scale-100 md:-left-[180px] lg:-left-[130px] xl:left-0"
			>
				<div
					class="slide-in-out absolute -left-[10px] top-[40px] w-full sm:left-[150px]"
				>
					<div
						class="h-[40px] w-[150px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FEC1A5]"
					/>
				</div>
				<div
					class="slide-in-out absolute -left-[30px] top-[20px] w-full sm:left-[100px]"
				>
					<div
						class="h-[40px] w-[100px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FCE8C3]"
					/>
				</div>
				<div
					class="slide-in-out absolute -left-[80px] top-[60px] w-full sm:left-[40px]"
				>
					<div
						class="h-[40px] w-[100px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FCE8C3]"
					/>
				</div>
			</div>

			<!-- group TR -->
			<div
				class="relative left-[200px] top-0 w-full scale-75 sm:left-[470px] sm:top-[20px] sm:scale-100 md:left-[550px] md:top-0 lg:left-[700px] xl:left-[800px] xl:top-[20px]"
			>
				<div
					class="slide-in-out absolute -left-[120px] top-[40px] w-full"
				>
					<div
						class="h-[40px] w-[100px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FF8BA0]"
					/>
				</div>
				<div class="slide-in-out absolute left-0 top-[60px] w-full">
					<div
						class="h-[40px] w-[100px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FF8BA0]"
					/>
				</div>
				<div
					class="slide-in-out absolute -left-[50px] top-[100px] w-full"
				>
					<div
						class="h-[40px] w-[100px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FF8BA0]"
					/>
				</div>
			</div>

			<!-- titles -->
			<div class="relative top-0 z-20 w-full md:top-[10px]">
				<div
					class="slide-in absolute -left-[50px] top-[50px] z-10 flex w-full flex-col items-center justify-center sm:-left-[20px] md:-left-[250px] md:top-[40px] md:scale-90 lg:-left-[280px] lg:scale-100 xl:-left-[300px] xl:top-[50px]"
				>
					<div
						class="h-[50px] w-[200px] skew-x-[-20deg] transform bg-white"
					/>
					<div
						class="absolute font-heading text-[2.5rem] font-semibold text-[#FEC1A5]"
					>
						SPRING
					</div>
				</div>
				<div
					class="slide-in absolute left-[60px] top-[90px] flex w-full flex-col items-center justify-center sm:left-[50px] md:-left-[220px] md:top-[80px] md:scale-90 lg:-left-[220px] lg:scale-100 xl:-left-[240px] xl:top-[90px]"
				>
					<div
						class="h-[50px] w-[140px] skew-x-[-20deg] transform bg-white"
					/>
					<div
						class="absolute font-heading text-[2.5rem] font-semibold text-[#FF8BA0]"
					>
						SALE
					</div>
				</div>
				<div
					class="slide-in absolute top-[250px] z-10 flex w-full scale-90 flex-col items-center justify-center md:top-[0px] lg:scale-100 xl:top-[20px]"
				>
					<div
						class="h-[34px] w-[320px] skew-x-[-20deg] transform from-[#FEC1A5] to-[#FF8BA0] bg-gradient-[90deg]"
					/>
					<div class="absolute text-[1.5rem] font-medium text-white">
						Big Savings You Can't Miss!
					</div>
				</div>
			</div>

			<!-- group BL -->
			<div
				class="relative left-[30px] top-[250px] z-10 w-full scale-75 sm:left-[120px] sm:scale-100 md:left-[20px] md:top-[80px] lg:-left-[40px] lg:top-[105px] lg:z-30 xl:left-[50px]"
			>
				<div
					class="slide-in-out absolute -left-[50px] top-[0px] w-full md:left-[50px]"
				>
					<div
						class="h-[40px] w-[100px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FCE8C3]"
					/>
				</div>
				<div
					class="slide-in-out absolute -left-[30px] top-[30px] w-full md:left-[60px]"
				>
					<div
						class="h-[40px] w-[150px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FCE8C3]"
					/>
				</div>
				<div
					class="slide-in-out absolute -left-[80px] top-[40px] w-full md:left-[10px]"
				>
					<div
						class="h-[40px] w-[100px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FCE8C3]"
					/>
				</div>
			</div>

			<!-- group BR -->
			<div
				class="relative left-[0px] top-[220px] w-full sm:left-[100px] sm:scale-100 md:left-[140px] md:top-[140px] lg:left-[280px] xl:left-[340px] xl:top-[180px]"
			>
				<div
					class="slide-in-out absolute -left-[50px] top-[0px] w-full md:left-[50px]"
				>
					<div
						class="h-[40px] w-[100px] skew-x-[-20deg] transform bg-gradient-to-r from-transparent to-[#FF8BA0]"
					/>
				</div>
			</div>

			<div
				class="slide-in group absolute left-1/2 top-[300px] z-50 flex w-fit -translate-x-1/2 cursor-pointer flex-col items-center justify-center md:left-[420px] md:top-[80px] md:translate-x-full lg:left-[600px] xl:left-[700px] xl:top-[100px]"
			>
				<div
					class="group h-[34px] w-[130px] skew-x-[-20deg] bg-white transition-all duration-300 group-hover:bg-blue-400"
					@click="navigateTo('/cars/subscribe')"
				/>
				<span
					class="pointer-events-none absolute text-[1rem] text-[#F45F76] transition-all duration-300 group-hover:text-white"
				>
					Find out more
				</span>
			</div>

			<CarbarImage
				image="img/campaigns/spring-sale-2025/mazda.webp"
				alt-text="Mazda CX-30"
				image-width-class="w-full sm:w-auto"
				image-height-class="h-auto sm:h-[150px] lg:h-[160px]"
				class="slide-in z-20 m-auto mt-[110px] md:mt-8 xl:mt-12"
			/>

			<TermsAndConditions
				:is-full-width="false"
				custom-class="absolute bottom-4 md:right-4 lg:right-10 z-50"
				font-color="text-[#F45F76] md:text-white"
			>
				*
				<CarbarLink
					text="Terms & conditions"
					text-color="text-[#F45F76] md:text-white"
					underline-color="decoration-[#F45F76] md:decoration-white"
					hover-color="hover:decoration-[#BC1932] hover:text-[#BC1932] md:hover:decoration-gray-300 md:hover:text-gray-300"
					font-size="text-xsm"
					class="cursor-pointer"
					@click="
						goToPageAndScroll(
							'/terms-and-conditions',
							'#spring-sale-promotion',
							true
						)
					"
				/>
				apply
			</TermsAndConditions>
		</div>
	</div>
</template>

<script setup>
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const mounted = ref(false)

onMounted(() => {
	setTimeout(() => {
		mounted.value = true
	}, 50)

	document.querySelectorAll('.slide-in-out').forEach((el) => {
		/* eslint-disable-next-line security-node/detect-insecure-randomness */
		const randomDelay = (Math.random() * 1.5).toFixed(2)
		el.style.animationDelay = `${randomDelay}s`
	})
})
</script>

<style lang="scss">
.slide-in {
	animation: slide-in 0.3s ease forwards;
}

@keyframes slide-in {
	0% {
		transform: translateX(-100%);
		opacity: 0;
	}
	100% {
		transform: translateX(0);
		opacity: 1;
	}
}

.slide-in-out {
	position: relative;
	transform: translateX(-100%);
	opacity: 0;
	animation: slide-in-out 6s ease-in-out infinite;
}

@keyframes slide-in-out {
	0% {
		transform: translateX(-100%);
		opacity: 0;
	}
	10% {
		transform: translateX(0);
		opacity: 1;
	}
	90% {
		transform: translateX(2%);
		opacity: 1; /* stays here for ~4s */
	}
	100% {
		transform: translateX(100%);
		opacity: 0;
	}
}
</style>
